module.exports = __webpack_public_path__ + "static/media/sello_garantia_habi.2cbfe6f4.svg";